import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';
import AuthModals from './components/AuthModals.vue';

export default defineModule({
    id: 'auth',
    contributes: {
        // Loaded eagerly so `open-login` events fired during startup are not missed.
        'app.global': [
            { key: 'authModals', component: overridable('AuthModals', AuthModals) }
        ],
        'bottom.nav': [
            { key: 'login', order: 20, icon: 'images/icons/nav-login.png', guest: true, action: 'open-login' }
        ]
    }
});
